import { cloudflareImageLoader } from '@dustin-web/microsite-components/src/image/cloudflare-loader'
import type { Parser } from '.'

const DEFAULT_WIDTH = 600
const CLOUDFLARE_IMAGE_URL = 'https://cf-images.dustin.eu/cdn-cgi/image/'
const CMS_CLOUDFLARE_IMAGE_URL =
  'https://cf-images.dustin.eu/cdn-cgi/image/format=auto,quality=75,fit=contain/'

const unwrapCmsCloudflareImageUrl = (src: string) =>
  src.startsWith(CMS_CLOUDFLARE_IMAGE_URL) ? src.slice(CMS_CLOUDFLARE_IMAGE_URL.length) : src

const formatBackgroundImageUrl = (src: string, width: number) => {
  if (src.startsWith(CLOUDFLARE_IMAGE_URL) && !src.startsWith(CMS_CLOUDFLARE_IMAGE_URL)) {
    return src
  }

  return cloudflareImageLoader({
    src: unwrapCmsCloudflareImageUrl(src),
    width,
    options: { objectFit: false },
  })
}

export const imageParser: Parser = node => {
  // if (node.name === 'img' && node.attribs?.['src'].length > 0) {
  //   return <Image src={node.attribs.src} width={DEFAULT_WIDTH} />
  // }

  if (
    node.type === 'tag' &&
    node.attribs?.['style'] &&
    node.attribs['style'].includes('background-image')
  ) {
    const style = node.attribs['style']

    const regexp = /url(?:\(['"]?)(.*?)(?:['"]?\))/
    const extractedUrl = regexp.exec(style)?.[1]

    if (!extractedUrl) {
      return node
    }

    // TODO: This is a hack to get the hero image to be full width
    const width = node.attribs['class']?.includes('-hero') ? 1920 : DEFAULT_WIDTH
    const updatedUrl = formatBackgroundImageUrl(extractedUrl, width)

    node.attribs.style = node.attribs.style.replace(extractedUrl, updatedUrl)

    return node
  }
}
